// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"0f7a2960","840":"148280cb","926":"4e5784b9"}[chunkId] + ".chunk.js";
};